// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';

// require main js file
require('@js/index');
require('@js/slider');
require('@js/accordion');
require('@js/map');
require('@js/section-scroll');
require('@js/cursor');
require('@js/tab');
require('@js/select');
require('@js/mobile-menu');
require('@js/scrolling-parallax-text');
require('@js/modal');
